module.exports = __webpack_public_path__ + "img/2018_1.c43ba215.webp";